import * as Yup from 'yup'

const MOTIF_MAX = 2000

export const SignupSchema = Yup.object().shape({
  motif: Yup.string()
    .required(' ')
    .max(MOTIF_MAX, 'myRequest_characters_max_error')
})
